import React, { Component } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { withRouter } from "react-router-dom";
import currencyFormatter from "currency-formatter";
import { getCheckout } from "../api/getCheckout";
import rackerLogo from "../images/racker-logo.png";

class CheckoutForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      processing: false,
      email: "",
      name: "",
      currency: props.currency,
      charityId: props.charityId,
      company: props.company,
      customerCoveringFee: false,
    };

    this.emailUpdate = this.emailUpdate.bind(this);
    this.nameUpdate = this.nameUpdate.bind(this);
    this.handleCustomerCoveringFee = this.handleCustomerCoveringFee.bind(this);
  }

  handleCustomerCoveringFee(event) {
    this.setState({ customerCoveringFee: event.target.checked });
  }

  emailUpdate(event) {
    this.setState({ email: event.target.value });
  }

  nameUpdate(event) {
    this.setState({ name: event.target.value });
  }

  handleSubmit = async (event) => {
    if (this.state.name === "" || this.state.email === "") {
      this.setState({ processing: false });
      alert("Please provide your name and email.");
      event.preventDefault();
      return;
    }
    const { amount } = this.props;
    this.setState({ processing: true });
    event.preventDefault();
    const calculatedAmount = 100 * amount;

    const checkout = await getCheckout(
      calculatedAmount,
      this.state.currency,
      this.state.name,
      this.state.email
    );
    const stripePromise = loadStripe(checkout.response.publicKey);
    const stripe = await stripePromise;
    const result = await stripe.redirectToCheckout({
      sessionId: checkout.response.checkoutId,
    });
  };

  render() {
    const currencySymbol = this.state.currency === 'USD' || this.state.currency === 'usd' ? '$' : 
                          this.state.currency === 'EUR' || this.state.currency === 'eur' ? '€' : 
                          this.state.currency === 'GBP' || this.state.currency === 'gbp' ? '£' : 
                          this.state.currency === 'CAD' || this.state.currency === 'cad' ? '$' : 
                          this.state.currency === 'AUD' || this.state.currency === 'aud' ? '$' : 
                          this.state.currency === 'JPY' || this.state.currency === 'jpy' ? '¥' : 
                          this.state.currency === 'INR' || this.state.currency === 'inr' ? '₹' : '';
    
    return (
      <div className="min-h-screen bg-gray-50">
        {/* Purple Header */}
        <div className="text-white py-12 pb-20" style={{ backgroundColor: '#7f0b86' }}>
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          </div>
        </div>

        <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 -mt-12">
          {/* Form Card */}
          <div className="bg-white rounded-lg shadow-lg border border-gray-300 p-8">
            {/* Logo */}
            <img 
              src={rackerLogo}
              alt="Racker Logo" 
              className="w-full max-h-36 object-contain mb-6"
            />
            
            {/* Donation Amount Display */}
            <div className="text-center mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-2">
                Your Donation
              </h2>
              <p className="text-3xl font-bold" style={{ color: '#7f0b86' }}>
                {currencySymbol}{this.props.amount} {this.state.currency.toUpperCase()}
              </p>
              <p className="text-gray-600 mt-2">to Racker2Racker</p>
            </div>

            {/* Form */}
            <form onSubmit={this.handleSubmit}>
              <div className="space-y-4 mb-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Name *
                  </label>
                  <input
                    type="text"
                    placeholder="Enter your full name"
                    value={this.state.name}
                    onChange={this.nameUpdate}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:border-transparent"
                    style={{ '--tw-ring-color': '#7f0b86' }}
                    required
                  />
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Email *
                  </label>
                  <input
                    type="email"
                    placeholder="Enter your email address"
                    value={this.state.email}
                    onChange={this.emailUpdate}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:border-transparent"
                    style={{ '--tw-ring-color': '#7f0b86' }}
                    required
                  />
                </div>
              </div>

              {/* Submit Button */}
              <button 
                type="submit" 
                disabled={this.state.processing}
                className="w-full text-white py-3 px-4 rounded-full font-medium transition duration-200 disabled:bg-gray-400 disabled:cursor-not-allowed"
                style={{ backgroundColor: this.state.processing ? '#9CA3AF' : '#7f0b86' }}
                onMouseEnter={(e) => !this.state.processing && (e.target.style.backgroundColor = '#6a0a72')}
                onMouseLeave={(e) => !this.state.processing && (e.target.style.backgroundColor = '#7f0b86')}
              >
                {this.state.processing ? "Processing..." : "Complete Donation"}
              </button>

              {/* Back Link */}
              <div className="text-center mt-4">
                <button
                  type="button"
                  onClick={() => window.history.back()}
                  className="text-sm font-medium"
                  style={{ color: '#7f0b86' }}
                  onMouseEnter={(e) => e.target.style.color = '#6a0a72'}
                  onMouseLeave={(e) => e.target.style.color = '#7f0b86'}
                >
                  ← Back to campaign
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

class DonateForm extends Component {
  render() {
    return (
      <CheckoutForm
        amount={this.props.location.state?.amount || 0}
        charityId={parseInt(this.props.location.state?.charityId || 1)}
        currency={this.props.location.state?.currency || "usd"}
        company={this.props.location.state?.company}
      />
    );
  }
}

export default withRouter(DonateForm);
